import { render, staticRenderFns } from "./EditorComponentColumn.vue?vue&type=template&id=2fa7de5d&"
import script from "./EditorComponentColumn.vue?vue&type=script&lang=js&"
export * from "./EditorComponentColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports